import {USER_CLONE} from '~/frontend/src/constants';

export type CloneUserAction = {
    type : typeof USER_CLONE;
}

/**
 * @memberOf! Actions
 *
 * @return {CloneUserAction}
 */
const cloneUser = () : CloneUserAction => {
    return {
        type: USER_CLONE
    };
}

export type CloneUser = typeof cloneUser;

export default cloneUser;
